import { render, staticRenderFns } from "./qianbao.vue?vue&type=template&id=2345714e&scoped=true"
import script from "./qianbao.vue?vue&type=script&lang=js"
export * from "./qianbao.vue?vue&type=script&lang=js"
import style0 from "./qianbao.vue?vue&type=style&index=0&id=2345714e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345714e",
  null
  
)

export default component.exports